import { useMemo } from "react";
import { useGetReferralSourceQuery } from "services/referral-sources";
import useSubReferralSourceObject from "./use-sub-referral-source-source-object.hook";

export default function useSubReferralSourceOptions(
  id: number | null | undefined,
  subReferralSourceId: number | null | undefined
) {
  const { data: referralSource } = useGetReferralSourceQuery(Number(id), {
    skip: !Boolean(id),
  });
  const currentSubReferralSourceObject = useSubReferralSourceObject(
    subReferralSourceId,
    referralSource?.referred_type
  );
  const subReferralSourceOptions = useMemo(() => {
    return referralSource?.children
      ?.filter((child) => child.is_active)
      ?.map(({ id, name }) => ({
        value: String(id),
        label: name,
      }));
  }, [referralSource]);

  return useMemo(() => {
    return {
      subReferralSourceOptions: subReferralSourceOptions ?? [],
      referredType: referralSource?.referred_type,
      currentSubReferralSourceObject,
    };
  }, [
    currentSubReferralSourceObject,
    referralSource?.referred_type,
    subReferralSourceOptions,
  ]);
}
